<template>
  <div id='editor' ref='editor'></div>
</template>

<script>
import * as ace from 'brace';
import 'brace/mode/python';
import 'brace/theme/monokai';

export default {
  name: 'AceEditor',
  props: {
    lang:String,
    theme:String,
    options:Object,
    width:String,
    height:String,
    zoom:Number,
    disabled:Boolean
  },
  data:function () {
    return {
      editor: Object,
      contentBackup:"",
      z:0
    }
  },
  methods: {
    px:function (n) {
      if( /^\d*$/.test(n) ){
        return n+"px";
      }
      return n;
    },
    getPython() {
      return this.editor.getValue();
    },
    onChange() {
      if (!this.disabled)
        this.$emit('changed', this.editor.getValue());
    },
    load(val) {
      //console.log(val);
      this.editor.setValue(val,1);
    },
    resize() {
      let _this = this;
      window.requestAnimationFrame(function() {_this.editor.resize();});
    },
    toggleDarkMode(b) {
      if (b) this.editor.setTheme('ace/theme/'+(this.theme||'monokai'));
      else this.editor.setTheme();
    }
  },
  watch: {
    zoom: function (zoom) {
      this.editor.setFontSize(this.editor.getFontSize()+((zoom-this.z)))
      this.z = zoom;
    },
    theme:function (newTheme) {
      this.editor.setTheme('ace/theme/'+newTheme);
    },
    lang:function (newLang) {
      this.editor.getSession().setMode('ace/mode/'+newLang);
    },
    options:function(newOption) {
      this.editor.setOptions(newOption);
    },
    height:function() {
      this.resize();
    },
    width:function() {
      this.resize();
    },
    disabled: function(e) {
      this.editor.setReadOnly(e);
    }
  },
  beforeDestroy: function() {
    if (typeof(this.editor) !== undefined) {
      this.editor.destroy();
      this.editor.container.remove();
    }
  },
  mounted () {
    this.editor = ace.edit('editor');
    this.editor.setAutoScrollEditorIntoView(true);
    this.editor.setShowInvisibles(true);
    this.editor.$blockScrolling = Infinity;
    this.editor.getSession().on('change', this.onChange);
    this.editor.getSession().setMode('ace/mode/'+(this.lang||'python'));
    this.editor.getSession().setOptions({
        tabSize: 4,
        useSoftTabs: false
    });
    this.editor.setReadOnly(this.disabled);
    this.editor.setValue('',1);
    this.editor.setShowPrintMargin(false);
    this.$emit('loaded');
    this.toggleDarkMode(true);
  }
}
</script>

<style scoped>
#editor {
  width:100%;
  height: 100%;
  resize:vertical;
}
</style>
